<template>
  <div class="rank-wrapper" v-if="typeof(rankData['leagueList']) != 'undefined' && Object.keys(rankData['leagueList']).length > 0">
    <div class="rank-content">
      <div class="rank-title">
        <i class="rank-title-i"></i>
        <span>{{ langConfig.index[langConfig.curLang]['RANK']['TITLE'] }}</span>
        <i class="rank-title-tips" @click="rankTipsIsShow()"></i>
      </div>

      <div class="rank-model-tab">
        <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['MODEL_TITLE']">
          <span :class="[{on: modelTab == index}]" :key="index" @click="modelTabChange(index)">{{ item }}</span>
        </template>
      </div>

      <div class="rank-main">
        <div class="rank-box" :class="[{'rank-box-show': modelTab == 0}]">
          <div class="rank-box-top rank-top-bg-0">
            <div class="rank-box-type">
              <h4>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][0] }}</h4>
              <p>{{ langConfig.txtLang[langConfig.curLang]['MODEL_SUB_TITLE'][0] }}</p>
            </div>
            <div class="rank-box-right">
              <div class="rank-box-type-txt">Goals & Scores</div>
              <div class="rank-tab">
                <span :class="index==poisson[2]*1 ? 'on' : ''" v-for="(item, index) in langConfig.index[langConfig.curLang]['RANK']['MODEL_TAB']" :key="index" @click="sortTabChange(0, index)" :title="langConfig.index[langConfig.curLang]['RANK']['TIPS'][index]"><em><i></i></em>{{ item }}</span>
              </div>
            </div>
            
          </div>
          <div class="rank-box-con">
            <ul class="rank-list">
              <li :class="((index + 1) % 2 != 0) ? 'odd_bg' : ''" v-for="(item, index) in rankData[poisson[poisson[2]]]" :key="index" :data-id="item.leagueId">
                <div class="rank-no"><i :class="index < 3 ? 'no-'+(index+1) : '' ">{{ index > 2 ? index+1 : '' }}</i></div>
                <div class="rank-logo"><span class="logo"><img :src="common.leagueImgGet(item.leagueId, 20)" @error="common.imgError($event, 'team')" /></span></div>
                <div class="rank-name">
                  <span class="name">{{ rankData['leagueList'][item.leagueId]['fullName'] }}</span>
                  <span class="result">{{ langConfig.index[langConfig.curLang]['RANK']['HIT'].replace('?1', item['lastCount']).replace('?2', item['lastHit']) }}</span>
                </div>
                <div class="rank-pre">{{ poisson[2] == 1 ? '+' : '' }}{{ item[pre[poisson[2]]] }}%</div>
                <div class="rank-fav" v-if="index==0">
                  <el-popover
                    placement="bottom-end"
                    trigger="manual"
                    v-model="visible.fav"
                    :visible-arrow="false"
                    popper-class="my-popover fav-popover"
                    :popper-options="{boundariesElement: 'body'}"
                  >
                    <div class="popover-tips-box" @click="popoverIsShow('fav', false)">
                      <div class="popover-tips-txt">Click to follow the league and receive automatic notifications for new predictions.</div>
                      <div class="popover-tips-close"></div>
                    </div>
                    <i class="fav" :class="isFavLeagueState(item.leagueId)" @click.stop="followLeague($event, rankData['leagueList'][item.leagueId], 0)"  slot="reference"></i>
                  </el-popover>
                </div>
                <div class="rank-fav" v-if="index!=0">
                  <i class="fav" :class="isFavLeagueState(item.leagueId)" @click.stop="followLeague($event, rankData['leagueList'][item.leagueId], 0)"  slot="reference"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="rank-box" :class="[{'rank-box-show': modelTab == 1}]">
          <div class="rank-box-top rank-top-bg-1">
            <div class="rank-box-type">
              <h4>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][1] }}</h4>
              <p>{{ langConfig.txtLang[langConfig.curLang]['MODEL_SUB_TITLE'][1] }}</p>
            </div>
            <div class="rank-box-right">
              <div class="rank-box-type-txt">1x2</div>
              <div class="rank-tab">
                <span :class="index==margin[2]*1 ? 'on' : ''" v-for="(item, index) in langConfig.index[langConfig.curLang]['RANK']['MODEL_TAB']" :key="index" @click="sortTabChange(1, index)" :title="langConfig.index[langConfig.curLang]['RANK']['TIPS'][index]"><em><i></i></em>{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="rank-box-con">
            <ul class="rank-list">
              <li :class="((index + 1) % 2 != 0) ? 'odd_bg' : ''" v-for="(item, index) in rankData[margin[margin[2]]]" :key="index" :data-id="item.leagueId">
                <div class="rank-no"><i :class="index < 3 ? 'no-'+(index+1) : '' ">{{ index > 2 ? index+1 : '' }}</i></div>
                <div class="rank-logo"><span class="logo"><img :src="common.leagueImgGet(item.leagueId, 20)" @error="common.imgError($event, 'team')" /></span></div>
                <div class="rank-name">
                  <span class="name">{{ rankData['leagueList'][item.leagueId]['fullName'] }}</span>
                  <span class="result">{{ langConfig.index[langConfig.curLang]['RANK']['HIT'].replace('?1', item['lastCount']).replace('?2', item['lastHit']) }}</span>
                </div>
                <div class="rank-pre">{{ margin[2] == 1 ? '+' : '' }}{{ item[pre[margin[2]]] }}%</div>
                <div class="rank-fav"><i class="fav" :class="isFavLeagueState(item.leagueId)" @click.stop="followLeague($event, rankData['leagueList'][item.leagueId], 1)" ></i></div>
              </li>
            </ul>
          </div>
        </div>

        <div class="rank-box" :class="[{'rank-box-show': modelTab == 2}]">
          <div class="rank-box-top rank-top-bg-2">
            <div class="rank-box-type">
              <h4>{{ langConfig.txtLang[langConfig.curLang]['MODEL_TITLE'][2] }}</h4>
              <p>{{ langConfig.txtLang[langConfig.curLang]['MODEL_SUB_TITLE'][2] }}</p>
            </div>
            <div class="rank-box-right">
              <div class="rank-box-type-txt">1x2 & AH & O/U</div>
              <div class="rank-tab">
                <span :class="index==diff[2]*1 ? 'on' : ''" v-for="(item, index) in langConfig.index[langConfig.curLang]['RANK']['MODEL_TAB']" :key="index" @click="sortTabChange(2, index)" :title="langConfig.index[langConfig.curLang]['RANK']['TIPS'][index]"><em><i></i></em>{{ item }}</span>
              </div>
            </div>
          </div>
          <div class="rank-box-con">
            <ul class="rank-list">
              <li :class="((index + 1) % 2 != 0) ? 'odd_bg' : ''" v-for="(item, index) in rankData[diff[diff[2]]]" :key="index" :data-id="item.leagueId">
                <div class="rank-no"><i :class="index < 3 ? 'no-'+(index+1) : '' ">{{ index > 2 ? index+1 : '' }}</i></div>
                <div class="rank-logo"><span class="logo"><img :src="common.leagueImgGet(item.leagueId, 20)" @error="common.imgError($event, 'team')" /></span></div>
                <div class="rank-name">
                  <span class="name">{{ rankData['leagueList'][item.leagueId]['fullName'] }}</span>
                  <span class="result">{{ langConfig.index[langConfig.curLang]['RANK']['HIT'].replace('?1', item['lastCount']).replace('?2', item['lastHit']) }}</span>
                </div>
                <div class="rank-pre">{{ diff[2] == 1 ? '+' : '' }}{{ item[pre[diff[2]]] }}%</div>
                <div class="rank-fav"><i class="fav" :class="isFavLeagueState(item.leagueId)" @click.stop="followLeague($event, rankData['leagueList'][item.leagueId], 2)" ></i></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="rankTipsShow" class="van-popup-m"
      :closeable="false"
      :position="screenWidth>767?'center':'bottom'" 
      get-container="#app">
        <div class="intro-tips-box">
            <div class="intro-tips-top">
                <h4>Ranking List Instructions</h4>
                <span class="intro-tips-close" @click="rankTipsIsShow()"></span>
            </div>
            <div class="intro-main">
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <div class="intro-dec-txt">
                      <p>We take each league as the main subject, calculate the <span>hit rate</span> and <span>yield</span> of the predicted matches for each league, and list the top 5 leagues for each algorithm to help you follow the leagues with excellent records.</p>
                      <div class="intro-dec-sub">
                        <p><span>Hit Rate: </span>"The percentage of correct predictions."</p>
                        <p><span>YIELD: </span>"The return on investment from betting."</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="intro-dec" v-if="false">
                  <div class="intro-dec-title">
                    <i></i>
                    <p>Instruction of the LIVE-ALL switch button in the upper right corner of the module:</p>
                  </div>
                  <div class="intro-dec-sub">
                    <p><span>LIVE: </span>The ranking list only shows the top 5 leagues with unfinished matches currently.</p>
                    <p><span>ALL: </span>The ranking list shows the top 5 leagues recommended recently.</p>
                  </div>
                </div>
                <div class="intro-dec">
                  <div class="intro-dec-title">
                    <i></i>
                    <div class="intro-dec-txt">
                      <p>To not miss the new match predictions of your favorite league, you can click the follow button (star icon on the right). After following, when there are new match prediction results for that league, we will send you a notification through your browser.</p>
                      <div class="intro-img"><img src="~@/assets/images/rank-intro-img.png" /></div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
  
	export default {
    name: 'rank',
    components: {
    },
    
    props: {
      myLeague: {
        type: Object,
        default: () => {}
      },
      rankData: {
        type: Object,
        default: () => {}
      }
    },

		data(){
			return{
        poisson: ['poissonHitList', 'poissonProfitList', 0 ], // 泊松
        margin: ['marginHitList', 'marginProfitList', 0], // Margin
        diff: ['diffHitList', 'diffProfitList', 0], // 差异
        pre: ['hitrate', 'profit'], // 百分比
        //myLeague: {}, // 我关注的联赛
        modelTab: 0, // 移动端切换

        visible: {
          fav: false,
        },

        rankTipsShow: false,
        screenWidth:2000,
      }
		},

    computed: {
      
    },

    mounted(){
      this.screenWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
    },

		methods:{
      // 模型切换
      modelTabChange(val){
        let _val = val;
        this.modelTab = _val;
      },
      // 排行榜tab
      sortTabChange(type,val){
        let _type = type, _val = val, _arr = [];
        if(_type == 0){
          _arr = [...this.poisson]
          _arr[2] = _val;
          this.poisson = _arr;
        }

        if(_type == 1){
          _arr = [...this.margin]
          _arr[2] = _val;
          this.margin = _arr;
        }

        if(_type == 2){
          _arr = [...this.diff]
          _arr[2] = _val;
          this.diff = _arr;
        }

        let eventName = 'LS_PC_H_Performance_Switch_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_H_Performance_Switch_Click';
        }

        this.common.googleEvent(eventName, {
            '切换到的tab': (val == 0 ? 'HitRate' : 'YIELD')
        });
      },

      
      // 联赛关注是否显示
      isFavLeagueState(leagueId){
        let _leagueId = leagueId, _myLeague = this.myLeague, _className= '';

        if(_myLeague != null && Object.keys(_myLeague).length > 0){
          if(typeof(_myLeague[_leagueId]) != 'undefined'){
            _className = 'fav-on';
          }
        }

        return _className;
      },

      // 联赛关注
			followLeague(event, obj, type){
        event.preventDefault();

        let eventName = 'LS_PC_Leagues_Follow_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_Leagues_Follow_Click';
        }
        
        this.common.googleEvent(eventName, {
            '联赛': obj['fullName'],
            '点击页面': this.langConfig.index[this.langConfig.curLang]['RANK']['RANK_EVENT'][type]
        });

        let that = this;

        let _obj = obj;
        this.common.followLeague(_obj, function(val){
          console.log(val)
          let _myLeague = {};
          _myLeague = val;
          //that.myLeague = _myLeague;
          that.$emit('onLeagueFollowChange', _myLeague);
        });
      },

      // 气泡提示是否可见
      popoverIsShow(type, boo){
        let _val = {...this.visible}, _type = type, _boo = boo;

        _val[_type] = _boo;

        this.visible = _val;
        
        if(!boo){
          this.common.infoStorage('popoverShow', true);
        }
      },

      // 是否显示弹窗
      rankTipsIsShow(){
        if(!this.rankTipsIsShow){
          let eventName = 'LS_PC_Help_Click';
          if(this.common.isMobile != 4){
              eventName = 'LS_Webapp_Help_Click';
          }

          this.common.googleEvent(eventName, {
              '点击位置': '首页-排行榜'
          });
        }

        this.rankTipsShow = !this.rankTipsShow;
      },

      popoverShow(){
        let that = this, _popovers = this.common.getStorage('popoverShow');
      
        if(_popovers != null){
          return;
        }

        if(typeof(this.rankData['leagueList']) != 'undefined' && Object.keys(this.rankData['leagueList']).length > 0){
          setTimeout(function(){
            that.popoverIsShow('fav', true);
            that.popoverClose();
          }, 500);
        }
      },

      popoverClose(){
        let that = this, _popovers = this.common.getStorage('popoverShow');
      
        if(_popovers != null){
          return;
        }

        setTimeout(function(){
          that.popoverIsShow('fav', false);
        }, 60*1000);
      },

      //获取屏幕宽度
      handleResize() {
        if(typeof window!='undefined'){
        this.screenWidth = window.innerWidth;
        }
      },
		},

		created(){
      
		},

    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    destroyed() {
      
    },

    watch: {
      'rankData': {
        immediate: true,
        handler(val){
          this.popoverShow();
        }
      }
    }
	};

</script>
<style lang="less" scoped>
@import '~@/style/index/rank.less';
</style>


// WEBPACK FOOTER //
// ./src/views/home/components/rank.vue